import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import Language from "../components/component.language";
import Currency from "../components/component.currency";
import Menu from "../components/component.menu";
import CartHeader from "../components/component.cart.header";
import DestinationSelector from "../components/component.destination.selector";
import Weather from "../components/component.weather";
import Search from "../components/component.search";
import Global from "../globals/global";
//if (typeof window === "undefined")  var window={}
const $ = window.$;
const location = window.location;

class header extends Global {
    constructor(props) {
        super(props);

        this.openModal = this.openModal.bind(this);  

        this.state = {};
    }

    openModal() {
        $.magnificPopup.open({
            items: {
                src: "#search_p",
            },
            type: "inline",
            fixedContentPos: true,
            fixedBgPos: true,
            overflowY: "auto",
            closeBtnInside: true,
            preloader: false,
            midClick: true,
            removalDelay: 300,
            mainClass: "my-mfp-zoom-in",
        });
    }

    render() {
        var disablepages = this.config().noheaderpages || [];
        const disable = disablepages.find((page) => {
            return location.pathname.search(page) != -1;
        });

        if (disable) return null;

        var agentmoduleclass = "";
        if (this.config().enableagentsearch) agentmoduleclass = "nav_editor";

        return (
            <header className={`back_blueh ${agentmoduleclass}`}>
                <div id="top_line">
                    <div className="container">
                        <div className="row">
                            <div className="col-6 icon_changec">
                                {this.config().destinations ? (
                                    <DestinationSelector
                                        locationNotification={true}
                                    />
                                ) : (
                                    ""
                                )}
                            </div>

                            <div className="col-6">
                                <ul id="top_links">
                                    {this.config().myaccount ? (
                                        <li>
                                            {" "}
                                            <NavLink to="/myaccount">
                                                {this.getglobaldata("user") ? (
                                                    <span>
                                                        <i className="far fa-user-circle"></i>{" "}
                                                        {
                                                            this.getglobaldata(
                                                                "user"
                                                            ).FirstName
                                                        }
                                                    </span>
                                                ) : (
                                                    this.t("My Account")
                                                )}
                                            </NavLink>
                                        </li>
                                    ) : (
                                        ""
                                    )}

                                    {this.getglobaldata("user") &&
                                    this.config().myaccount ? (
                                        <li>
                                            <NavLink
                                                to="/"
                                                onClick={this.logout.bind(this)}
                                            >
                                                {this.t("Logout")}
                                            </NavLink>
                                        </li>
                                    ) : (
                                        ""
                                    )}

                                            {/*
                                        <li>
                                             <a href="https://es.delmarboutiqueaccommodation.com/account/staff" className="login_top_b">
                                                 <i className="far fa-user-circle"></i>{" "} Log In
                                            </a>        
                                        </li> */} 
                         


                                    {this.config().languages ? (
                                        <li>
                                            <Language />
                                        </li>
                                    ) : (
                                        ""
                                    )}

                                    {this.config().currencies ? (
                                        <li>
                                            <Currency />
                                        </li>
                                    ) : (
                                        ""
                                    )}

                                    {this.config().search ? (
                                        <li>
                                            <a
                                                onClick={this.openModal}
                                                className="search_pop i_search"
                                            >
                                                <i className="icon_search"></i>
                                            </a>
                                        </li>
                                    ) : (
                                        ""
                                    )}
                                </ul>
                            </div>
                        </div>
                        {/*---- End row --- */}
                    </div>
                    {/*---- End container--- */}
                </div>
                {/*---- End top line--- */}

                <div className="container">
                    <div className="row">
                        <div className="col-3">
                            <div id="logo_home">
                                {/*
                                <h1>
                                    <a href="https://es.delmarboutiqueaccommodation.com/" title="delMarBoutiqueAccommodation">
                                       del Mar Boutique Accommodation
                                    </a>
                                </h1>*/}

                                <a href="https://es.delmarboutiqueaccommodation.com/" title="delMarBoutiqueAccommodation">
                                    <svg preserveAspectRatio="xMidYMid meet" data-bbox="0.264 0.049 2199.736 1425.951" viewBox="0 0 2200 1426"  xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" data-type="ugc" role="presentation" aria-hidden="true" aria-labelledby="svgcid--7176l5klphry"><title id="svgcid--7176l5klphry"></title>
                                            <g>
                                                <defs>
                                                    <linearGradient y2="835.9" x2="1022.04" y1="-25.276" x1="1196.68" gradientUnits="userSpaceOnUse" id="svgcid-5a115ebyg38f">
                                                        <stop offset="0" stop-color="#d69107"></stop>
                                                        <stop offset=".522" stop-color="#e8b141"></stop>
                                                        <stop offset="1" stop-color="#fad27b"></stop>
                                                    </linearGradient>
                                                </defs>
                                                <path d="M174 514c42-153 181-236 340-291C334 232 58 386 4 605c-26 159 84 230 321 96 130-83 245-170 357-259 121-96 242-184 363-261 52-29 103-10 56 78-47 86-93 172-140 258-101 189 7 291 178 180 81-56 152-119 219-185 36-31 72-62 107-93 80-62 133-52 129 42-5 54-9 108-14 163-2 121 79 154 207 138 171-39 296-100 413-164-328 89-617 193-509-125 65-190 15-266-98-234-60 18-125 50-200 110-90 78-179 157-264 239-103 99-164 80-84-53 43-67 85-135 128-203 29-49 58-98 86-146 68-158 11-214-102-173-109 46-220 110-331 190L334 551c-100 67-174 55-160-37z" fill="url(#svgcid-5a115ebyg38f)"></path>
                                                <path d="M7 1338h16c6 0 11 1 15 2 3 2 6 4 8 7s3 7 3 11-1 7-3 10-4 5-8 7c5 2 8 3 10 5 3 2 4 5 6 7 1 3 2 6 2 9 0 7-3 13-8 17-4 5-11 7-19 7H7v-82zm8 8v26h4c6 0 10 0 13-1 2-2 5-3 6-6 2-2 2-4 2-7 0-4-1-7-3-9-3-2-7-3-13-3h-9zm0 34v32h10c6 0 10-1 13-2s5-3 7-5c1-3 2-6 2-8 0-4-1-7-3-10-3-3-6-5-10-6-3 0-8-1-15-1h-4zm122-44c12 0 23 4 31 12s12 19 12 31-4 22-12 30c-8 9-18 13-30 13-13 0-23-4-31-13-8-8-13-18-13-30 0-8 2-15 6-22 4-6 9-12 16-16 6-3 13-5 21-5zm0 8c-6 0-12 1-17 4-5 4-10 8-13 13-3 6-4 12-4 18 0 10 3 18 10 25s15 10 24 10c7 0 12-2 18-5 5-3 9-7 13-12 3-6 4-12 4-18 0-7-1-13-4-18-4-5-8-9-13-13-6-3-12-4-18-4zm86-6h9v60c0 4 1 6 3 9 1 2 4 4 7 5s6 2 9 2 5 0 8-2c2-1 4-2 6-4s3-5 4-8v-62h9v49c0 8-1 14-3 18-1 5-4 9-8 12s-10 5-16 5-12-2-17-5c-4-3-7-7-9-12-1-4-2-9-2-18v-49zm93 8v-8h45v8h-19v74h-8v-74h-18zm81-8h9v82h-9v-82zm122 73l12 15h-10l-8-10c-7 4-14 6-23 6-12 0-22-4-30-13-9-8-13-18-13-30 0-8 2-15 6-22s9-12 15-16c7-3 14-5 22-5 12 0 22 4 31 12 8 9 12 19 12 31 0 6-1 12-3 17s-6 10-11 15zm-5-6c7-7 11-16 11-26 0-7-2-13-5-18s-7-9-13-13c-5-3-11-4-17-4s-12 1-17 4c-6 4-10 8-13 13-3 6-5 12-5 18 0 10 4 18 11 25 6 7 14 10 24 10 6 0 12-2 18-5l-19-23h10l15 19zm62-67h9v60c0 4 1 6 3 9 1 2 3 4 6 5 4 1 7 2 10 2 2 0 5 0 8-2 2-1 4-2 6-4 1-2 3-5 3-8 1-2 1-6 1-13v-49h9v49c0 8-1 14-3 18-1 5-4 9-8 12s-10 5-16 5-12-2-17-5c-4-3-8-7-9-12-1-4-2-9-2-18v-49zm101 0h47v8h-39v26h38v8h-38v32h38v8h-46v-82zm152 0l38 82h-9l-12-27h-36l-13 27h-9l39-82h2zm-1 17l-14 30h28l-14-30zm154-2l-6 5c-4-5-8-8-13-11-5-2-11-3-17-3s-12 1-18 4c-5 4-9 8-13 13-3 5-4 11-4 18 0 10 3 18 10 25s16 10 26 10c11 0 21-4 29-13l6 5c-4 5-9 9-15 12s-13 4-21 4c-14 0-25-5-33-14-7-8-11-18-11-30s4-22 13-30c8-8 19-12 31-12 8 0 15 1 21 4s11 8 15 13zm119 0l-7 5c-3-5-7-8-12-11-5-2-11-3-17-3s-12 1-18 4c-5 4-10 8-13 13s-4 11-4 18c0 10 3 18 10 25s15 10 26 10 21-4 28-13l7 5c-4 5-9 9-15 12s-13 4-21 4c-14 0-25-5-34-14-7-8-10-18-10-30s4-22 13-30c8-8 19-12 31-12 8 0 15 1 21 4s11 8 15 13zm82-17c12 0 22 4 31 12 8 8 12 19 12 31s-4 22-12 30c-9 9-19 13-31 13s-22-4-30-13c-9-8-13-18-13-30 0-8 2-15 6-22 4-6 9-12 15-16 7-3 14-5 22-5zm0 8c-6 0-12 1-17 4-6 4-10 8-13 13-3 6-5 12-5 18 0 10 4 18 11 25 6 7 14 10 24 10 6 0 12-2 18-5 5-3 9-7 12-12 3-6 5-12 5-18 0-7-2-13-5-18s-7-9-13-13c-5-3-11-4-17-4zm82 76l12-82h1l33 67 34-67h1l12 82h-8l-9-59-29 59h-2l-29-59-8 59h-8zm131 0l11-82h2l33 67 33-67h2l11 82h-7l-9-59-29 59h-2l-29-59-8 59h-8zm173-84c13 0 23 4 32 12 8 8 12 19 12 31s-4 22-12 30c-9 9-19 13-31 13s-22-4-31-13c-8-8-12-18-12-30 0-8 2-15 6-22 3-6 9-12 15-16 7-3 14-5 21-5zm1 8c-6 0-12 1-17 4-6 4-10 8-13 13-3 6-5 12-5 18 0 10 4 18 10 25 7 7 15 10 25 10 6 0 12-2 17-5 6-3 10-7 13-12 3-6 5-12 5-18 0-7-2-13-5-18s-7-9-13-13c-5-3-11-4-17-4zm86 76v-82h17c12 0 21 1 26 3 8 3 14 7 19 14 4 7 7 15 7 25 0 8-2 15-6 22-3 6-8 11-14 13-5 3-13 5-23 5h-26zm8-8h9c11 0 19-1 23-2 7-2 11-6 15-11 3-5 5-11 5-19s-2-15-6-20c-3-6-9-10-16-12-5-1-13-2-25-2h-5v66zm136-74l38 82h-9l-12-27h-36l-12 27h-10l39-82h2zm-1 17l-14 30h28l-14-30zm70-9v-8h45v8h-19v74h-8v-74h-18zm82-8h8v82h-8v-82zm92-2c12 0 22 4 31 12 8 8 12 19 12 31s-4 22-12 30c-9 9-19 13-31 13s-22-4-30-13c-9-8-13-18-13-30 0-8 2-15 6-22 4-6 9-12 15-16 7-3 14-5 22-5zm0 8c-6 0-12 1-17 4-6 4-10 8-13 13-3 6-4 12-4 18 0 10 3 18 10 25 6 7 15 10 24 10 6 0 12-2 18-5 5-3 9-7 12-12 3-6 5-12 5-18 0-7-2-13-5-18s-7-9-12-13c-6-3-12-4-18-4zm86 76v-82h2l54 63v-63h8v82h-2l-54-62v62h-8z" fill-rule="nonzero" fill="#ffffff"></path>
                                                <path d="M1101 1205c24 0 43 19 43 43 0 25-19 44-43 44s-44-19-44-44c0-24 20-43 44-43z" fill="#fad27b"></path>
                                                <path fill="#da9813" d="M283 1246h602v5H283v-5z"></path>
                                                <path d="M1010 1220c16 0 29 13 29 28 0 16-13 29-29 29s-28-13-28-29c0-15 12-28 28-28z" fill="#f0c05c"></path>
                                                <path d="M951 1229c11 0 19 9 19 19 0 11-8 20-19 20-10 0-19-9-19-20 0-10 9-19 19-19z" fill="#ecb94e"></path>
                                                <path d="M909 1236c6 0 12 6 12 12 0 7-6 13-12 13-7 0-12-6-12-13 0-6 5-12 12-12z" fill="#e3a830"></path>
                                                <path fill="#da9813" d="M1917 1246h-602v5h602v-5z"></path>
                                                <path d="M1190 1220c-16 0-29 13-29 28 0 16 13 29 29 29 15 0 28-13 28-29 0-15-13-28-28-28z" fill="#f0c05c"></path>
                                                <path d="M1249 1229c-11 0-19 9-19 19 0 11 8 20 19 20 10 0 18-9 18-20 0-10-8-19-18-19z" fill="#ecb94e"></path>
                                                <path d="M1291 1236c-7 0-12 6-12 12 0 7 5 13 12 13s12-6 12-13c0-6-5-12-12-12z" fill="#e3a830"></path>
                                                <path d="M361 998c0-28-8-50-23-68-15-17-34-31-56-39-23-9-46-14-68-17-13-2-24-3-33-4-11 0-22-1-32-1h-19l-9 1H96l-25 1H39l-28-1-6 1c-2 0-3 1-4 2 0 1 4 1 11 2h5c2 1 4 1 5 1 4 1 7 2 10 4 6 3 9 8 9 17v179l1 1v5c0 9-3 16-10 20-6 3-11 4-15 4-1 1-4 1-7 2H9s-1 0-1 1 3 1 10 1h50l8 1h23c10 1 16 1 17 1h4c13 0 22 1 28 1 9 0 18-1 28-1 7-1 17-2 31-3 23-2 45-7 67-14 23-9 43-20 59-36 9-9 16-18 21-27 4-11 7-22 7-34zm-43 0c0 22-6 41-18 56-12 14-27 25-46 32-2 1-7 3-13 5s-11 3-14 4c-6 1-10 2-13 3-2 0-6 1-11 2h-3c-17 2-34 3-50 3h-9c-23 0-39-3-46-9s-11-11-11-16l-2-180c0-11 12-17 37-17h13c15 0 33 1 53 4 21 2 41 7 61 15 21 8 38 20 52 36s20 37 20 62zm261 77c-1-4-2-6-3-6-1 1-2 1-3 3l-2 3c-3 10-11 16-24 20-11 3-25 5-40 5h-10l-8-1c-24 0-37-6-37-17v-85c0-5 4-8 10-8h54c6 0 12 1 19 4s11 8 12 16l2 4 2 2c2 0 3-2 3-6v-20s0-1 1-3v-3c1-2 1-3 1-3 1-1 1-2 2-4 2-4 3-7 3-7 0-1-1-2-2-2s-3 1-6 3l-5 3c-1 1-3 2-6 3s-8 1-15 1h-65c-5 0-8-1-9-3-2-3-3-5-3-6v-77c0-6 5-8 15-8h54c6 0 13 2 19 4 9 3 14 8 16 15l2 4 2 2h1c2 0 3-2 3-6 0-6 1-11 1-15l3-9c2-3 4-6 4-8-1-2-2-3-4-3s-4 1-6 1l-5 2H376l-1 1h-1c-1 0-1 0-1 1l9 3h1c3 0 6 1 8 1 3 1 6 2 8 2 7 2 10 6 10 12l-2 201c0 6-2 10-8 12-5 2-9 3-12 3-4 1-6 2-6 3 1 1 2 1 5 1h167c14 0 21-3 21-11 2-6 4-11 4-14l1-10zm262 9c0-4 0-7-1-11 0-4-1-5-2-5s-2 1-3 2l-3 4c-10 17-26 25-47 25h-45c-13 0-22-1-28-4-7-4-11-8-13-13-2-4-3-9-3-14V903c0-12 4-19 12-23 8-3 14-5 19-5 6-2 8-3 8-4 0 0-3-1-8-1h-24l-23 1h-28l-27-1h-5l-1 1h-1l-1 1 9 3c7 0 14 2 20 5 7 4 10 11 10 21v166c1 1 1 3 1 7s-1 8-2 12c-1 3-3 6-4 9-5 5-9 8-13 9-4 2-7 3-10 3s-5 1-6 2c1 1 3 1 6 1l18-1h74l20 1h67c23 0 34-9 34-26zm628 27c0-1-1-2-3-3l-5-2c-8 0-15-1-21-3s-10-5-12-8c-5-7-8-12-8-17l-32-205-1-3-2-5c-1-1-2-2-3-2-2 0-4 2-7 7l-139 200-144-199c-3-5-6-7-8-7s-3 1-4 2v1c0 2-1 3-1 4l-33 210c-2 10-6 17-13 21-6 3-10 5-14 5l-7 2h-1c0 1 3 1 8 1l15-1h46l19 1c4 0 6 0 6-1-1-1-3-2-6-2-7-2-13-3-16-5-4-3-6-6-7-9s-2-7-2-12l19-151 126 175 3 3c2 1 3 2 5 2 3 0 5-2 7-5l126-178 21 152c0 3 0 5 1 6v3c0 6-2 10-5 13-4 2-7 4-10 4-6 1-10 2-10 3s3 1 8 1h67l28 1 7 1h2zm347-2c-1-1-2-1-4-1l-6-1c-7 0-14-1-19-3-6-2-11-5-14-8-7-7-12-13-14-17l-119-206c-2-5-5-7-7-7s-4 1-5 2-1 2-1 2c-1 1-1 2-1 2l-114 210c-3 5-7 9-14 14-6 6-17 9-31 11l-4 1-3 1c1 0 2 1 5 1h98c-1-1-2-1-3-2l-6-1c-11-3-17-8-17-15l1-4 1-3 31-63c1-4 4-6 11-6h91c5 0 9 2 12 6l35 63c4 6 6 11 6 15 0 3-2 4-6 4-5 1-7 2-7 3s1 1 2 2l3 1h91l5-1h3zm-144-106c0 1-2 2-6 2h-80c-4 0-6-1-6-3s0-3 1-3l39-80 2-3c1-2 2-2 3-2 2 0 4 2 5 6l41 81c1 1 1 1 1 2zm527 105c0-1-3-1-8-1-6 0-14-1-26-4-12-2-24-7-36-14l-107-88c6-2 12-6 19-10 9-5 17-13 26-24 8-11 12-23 12-38 0-5-1-11-3-17-3-6-6-10-10-14-8-8-17-14-28-18-10-4-21-7-33-8-2 0-4-1-6-1h-11l-17-1h-15l-27 1h-61l-19-1h-4c-1 0-2 1-3 1 1 1 4 2 9 4 3 0 6 0 9 1l11 2c8 3 12 7 12 12v192c0 15-7 23-22 24l-6 2-2 1h-1c0 1 3 1 8 1l16-1h59l23 1 4-1s0-1-1-1c-1-1-2-1-2-2-23-1-35-9-35-24v-73h59l96 81c4 4 14 8 28 13 14 6 33 8 58 8h14l13-1h3c1-1 2-1 3-1 0 0 0-1 1-1zm-160-170c0 18-5 31-13 40-9 10-18 16-27 18-10 2-17 3-22 3l-14 1c-8 0-15 0-21-2-2 0-5-1-8-1l-1-1c-4 0-6 0-7-2-2-1-3-3-4-4V885c0-1 1-1 2-2s5-1 10-1l7-1c3 0 6-1 8-1h9c17 0 35 4 51 10 17 7 27 20 29 40v4l1 4z" fill-rule="nonzero" fill="#ffffff"></path>
                                                <path d="M2141 858v16h10c4 0 7-1 9-2 1-1 2-3 2-6s-1-5-2-6c-2-1-5-2-9-2h-10zm-6-5h24c1 1 2 1 3 2 2 1 4 2 5 4s1 4 1 7c0 2 0 4-1 6s-3 3-5 4c2 1 3 2 4 3s1 3 1 6l1 7v4c1 1 1 2 2 2v1h-7c-1-1-1-3-2-6v-6c0-3-1-5-2-6s-4-2-8-2h-10v20h-6v-46z" fill-rule="nonzero" fill="#ffffff"></path>
                                                <path d="M2152 834c24 0 43 19 43 42 0 24-19 43-43 43-23 0-42-19-42-43 0-23 19-42 42-42zm0 5c21 0 38 16 38 37s-17 38-38 38-37-17-37-38 16-37 37-37z" fill="#ffffff"></path>
                                            </g>
                                    </svg>
                                </a>
                            </div>
                        </div>

                        <nav className="col-9">
                            <a
                                className="cmn-toggle-switch cmn-toggle-switch__htx open_close"
                                href="javascript:void(0);"
                            >
                                <span>Menu mobile</span>
                            </a>
                            <div className="main-menu">
                                <div id="header_menu">
                                    <img
                                        src={this.image(
                                            "img/logo_sticky_2x_delmarboutiqueaccommodation.png"
                                        )}
                                        width="auto"
                                        height={34}
                                        alt="delmarboutiqueaccommodation"
                                        data-retina="true"
                                    />
                                </div>
                                <a
                                    href="#"
                                    className="open_close"
                                    id="close_in"
                                >
                                    <i className="icon_set_1_icon-77" />
                                </a>
                                <ul className="nav_bottom list-inline d-lg-flex justify-content-center">

                                    <li className="submenu">
                                        <a
                                            href="javascript:void(0);"
                                            className="show-submenu"
                                        >
                                            {this.t("About")}
           
                                        </a>
                                        <ul>
                                            <li>
                                                <a href="https://es.delmarboutiqueaccommodation.com/delmar">
                                                    Del Mar
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://es.delmarboutiqueaccommodation.com/pluscare">
                                                   Plus Care
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://es.delmarboutiqueaccommodation.com/contact">
                                                {this.t("Contact")}
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="submenu">
                                        <a
                                            href="javascript:void(0);"
                                            className="show-submenu"
                                        >
                                           {this.t("Guests")}
                                        </a>
                                        <ul>
                                            <li>
                                            {this.config().tours?<li><NavLink to="/home">{this.t("Tours")}</NavLink></li>:''}
                                            </li>
                                            <li>
                                                <a href="https://es.delmarboutiqueaccommodation.com/thebay">
                                                {this.t("The Bay")}
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://es.delmarboutiqueaccommodation.com/top-activities">
                                                {this.t("Top Activities")}
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://es.delmarboutiqueaccommodation.com/where-to-eat">
                                                {this.t("Where to Eat")}
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://es.delmarboutiqueaccommodation.com/supermarkets">
                                                {this.t("Supermarkets")}
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://es.delmarboutiqueaccommodation.com/transportation">
                                                {this.t("Transportation")}
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://es.delmarboutiqueaccommodation.com/services">
                                                {this.t("Services")}
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a href="https://es.delmarboutiqueaccommodation.com/hosts">
                                        {this.t("Hosts")}
                                        </a>
                                    </li>
                                    <li className="submenu">
                                        <a
                                            href="javascript:void(0);"
                                            className="show-submenu"
                                        >
                                            {this.t("Real State")}
                                        </a>
                                        <ul>
                                            <li>
                                                <a href="https://es.delmarboutiqueaccommodation.com/properties">
                                                {this.t("Properties")}
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                      {/*---- End top line--- 
                                    <li className="submenu">
                                        <a
                                            href="javascript:void(0);"
                                            className="show-submenu active_forever"
                                        >
                                            Experiencias{" "}
                                        </a>
                                        <ul>
                                            <li>
                                                <NavLink to="/home">
                                                    Elige tu destino
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink to="/tours/1">
                                                    Listado de Experiencias
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink to="/trendingrev">
                                                    Reseñas
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink to="/wishlist">
                                                    Favoritos
                                                </NavLink>
                                            </li>
                                            <li>
                                                <NavLink to="/contact">
                                                    Contacto
                                                </NavLink>
                                            </li>
                                        </ul>
                                    </li>*/}
                                    <li className="submenu">
                                        <a
                                            href="javascript:void(0);"
                                            className="show-submenu"
                                        >
                                            {this.t("Users")}
                                        </a>
                                        <ul>
                                            <li>
                                                <a href="https://es.delmarboutiqueaccommodation.com/account/staff">
                                                Staff
                                                </a>
                                            </li>
                                            <li>
                                                <a href="https://es.delmarboutiqueaccommodation.com/account/owners">
                                                {this.t("Owners")}
                                                </a>
                                            </li>
                                        </ul>
                                    </li>

                                    {/*menu responsive*/}

                                    <div className="resp_b">
                                        {this.config().destinations ? (
                                            <li>
                                                <DestinationSelector
                                                    locationNotification={false}
                                                />
                                            </li>
                                        ) : (
                                            ""
                                        )}

                                        {this.config().weather ? (
                                            <li>
                                                <Weather />
                                            </li>
                                        ) : (
                                            ""
                                        )}

                                        {this.config().languages ? (
                                            <li className="m-2">
                                                <Language
                                                    header={false}
                                                    className="form-control"
                                                />
                                            </li>
                                        ) : (
                                            ""
                                        )}

                                        {this.config().currencies ? (
                                            <li className="m-2">
                                                <Currency
                                                    header={false}
                                                    className="form-control"
                                                />
                                            </li>
                                        ) : (
                                            ""
                                        )}

                                        {this.config().myaccount ? (
                                            <li>
                                                {" "}
                                                <NavLink
                                                    to="/myaccount"
                                                    activeClassName="active"
                                                >
                                                    {this.t("My Account")}
                                                </NavLink>
                                            </li>
                                        ) : (
                                            ""
                                        )}

                                            {/* 
                                        <li>
                                             <a href="https://es.delmarboutiqueaccommodation.com/account/staff" className="login_top_b">
                                                 <i className="far fa-user-circle"></i>{" "} Log In
                                            </a>        
                                        </li> */} 

                                        {this.getglobaldata("user") &&
                                        this.config().myaccount ? (
                                            <li>
                                                <NavLink
                                                    to="/"
                                                    onClick={this.logout.bind(
                                                        this
                                                    )}
                                                >
                                                    {this.t("Logout")}
                                                </NavLink>
                                            </li>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </ul>
                            </div>
                            {/* End main-menu */}
                            <ul id="top_tools">
                                <li className="cart_home">
                                    <CartHeader />
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>

                {/*  chat icon --*/}
                <a
                    href="#"
                    className="chat_icon"
                    onClick={this.openchat.bind(this)}
                >
                    <img src={this.image("img/chat_icon.png")} />
                </a>
            </header>
        );
    }
}

export default header;
